<form (change)=saveForm() [formGroup]="loonTegenwoordigFg">
  @if(loonTegenwoordigeArbeid.length > 0) {
    <div formArrayName="loonTegenwoordigeArbeid">
      @for (item of loonTegenwoordigeArbeid.controls; track $index; let i = $index) {
        <div [formGroupName]="i" class="row">
          <div class="col-auto row" formGroupName="loon">
            <snelstart-ui-text-form-control (change)="saveForm()"
                                            [label]="i === 0 ? 'Werkgever' : ''"
                                            class="custom-input-250 col-auto"
                                            formControlName="omschrijving"
                                            id="omschrijving"
                                            snelstartUiBorderOnHover>
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Loon' : ''"
                                              [required]=true
                                              align="right"
                                              class="custom-input-150 col-auto"
                                              formControlName="bedrag"
                                              id="bedrag"
                                              prefix="€">
            </snelstart-ui-number-form-control>
          </div>
          @if(this.isDefAangifte) {
            <div class="row col-auto">
              @if(this.incomeTaxEntity.aangifte!.biljetSoort === "C") {
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'In NL onbelast deel' : ''"
                                                  align="right"
                                                  class="custom-input-150 "
                                                  formControlName="onbelastDeelLoonInNederland"
                                                  id="onbelastDeelLoonInNederland"
                                                  prefix="€">
                </snelstart-ui-number-form-control>
              }

              <snelstart-ui-number-form-control (change)="saveForm()"
                                                [decimals]="0"
                                                [label]="i === 0 ? 'Loonheffing' : ''"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150 "
                                                formControlName="loonheffing"
                                                id="loonheffing"
                                                prefix="€">
              </snelstart-ui-number-form-control>

              <snelstart-ui-number-form-control (change)="saveForm()"
                                                [decimals]="0"
                                                [label]="i === 0 ? 'Arbeidskorting' : ''"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150 "
                                                formControlName="arbeidskorting"
                                                id="arbeidskorting"
                                                prefix="€">
              </snelstart-ui-number-form-control>

            </div>
          }
          <div class="col-auto">
            <snelstart-ui-button (click)="verwijderRij(i)"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDelete"
                                 size="medium"
                                 type="secondary">
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  }
</form>

@if (loonTegenwoordigeArbeid.length === 0) {
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="invulKind"
                       type="link">Loon invullen
  </snelstart-ui-button>
} @else {
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="toevoegKind"
                       type="link">Loon toevoegen
  </snelstart-ui-button>
}

@if(this.aangifte.biljetSoort !== 'C' && this.heeftGeenOuderenkorting() && loonTegenwoordigeArbeid.length > 0) {
    <form [formGroup]="wajongFg">
      <div class="row mb-1">
        <div class="col-auto pt-1">
          <div *ngIf="!this.partnerBoolean">
            <p>Heeft {{ this.dataService.naamAangever }} in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
              recht op de jonggehandicaptenkorting (wajong)?</p>
          </div>
          <div *ngIf="this.partnerBoolean">
            <p>Heeft {{ this.dataService.naamPartner }} in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
              recht op de jonggehandicaptenkorting (wajong)?</p>
          </div>
        </div>
        <div class="col-2"></div>
        <div class="col-auto">
          <snelstart-ui-select-form-control (change)="saveForm()"
                                            [options]="optionsJaNee"
                                            class="custom-input-250"
                                            formControlName="krijgtWajong"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>
    </form>
}

